module.exports = __webpack_public_path__ + "img/etapas-title-mobile.4ccaac8e.svg";